import Cornerstone from './Cornerstone';
import Core from './Core';
import General from './General';
import Sources from './Sources';
import Texture from './Texture';

export default {
  Cornerstone,
  Core,
  General,
  Sources,
  Texture,
};
